import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { ui } from '../data/ui';
export function MobileCallBar() {
  const {
    t
  } = useLanguage();
  return <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/10 bg-navy-deep lg:hidden" data-id="element-239" data-mp="2eey2js8eyjfd">
      <a href={business.phoneHref} className="flex h-14 items-center justify-center gap-2 font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-240" data-mp="24n24uia8ovbo">
        <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="29fd2tflf671l" />
        {t(ui.callNow)}
      </a>
      <a href="#contact" className="flex h-14 items-center justify-center bg-leaf-strong font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-242" data-mp="1uqgy9siknc5q">
        {t(ui.freeEstimate)}
      </a>
    </div>;
}